import { useMemo } from 'react';

interface UseLoadingStateProps {
    selectedPropertyId: string | undefined;
    selectedOrderProperty: string | undefined;
    vendorsMap: Record<string, any> | undefined;
}

export const useLoadingState = ({
    selectedPropertyId,
    selectedOrderProperty,
    vendorsMap,
}: UseLoadingStateProps): boolean => {
    return useMemo(() => {
        const hasProperty = Boolean(selectedPropertyId);
        const hasOrderProperty = Boolean(selectedOrderProperty);
        const propertiesMatch = selectedOrderProperty === selectedPropertyId;
        const hasVendorsMap = Boolean(vendorsMap);

        return (
            !hasProperty ||
            !hasOrderProperty ||
            !propertiesMatch ||
            !hasVendorsMap
        );
    }, [selectedPropertyId, selectedOrderProperty, vendorsMap]);
};
